/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';

class QueueSectionComponent extends React.Component {
    render() {
        let timezone = this.props.user.detail.timezone,
            time = null,
            twoDaysFromNow = null,
            formatted = {};

        if (!timezone) {
            return null;
        }

        time = moment.tz(this.props.time * 1000, timezone);
        twoDaysFromNow = moment().tz(timezone).add(1, 'days')


        if (time.isBefore(twoDaysFromNow)) {
            formatted = time.calendar(null, {
                sameDay: '[Today]',
                nextDay: '[Tomorrow]'
            });
        } else {
            formatted = time.format('MMMM D, YYYY');
        }

        return (
            <div className="item-group-header queue-item-group-header">
                {formatted}
            </div>
        );

    }

};

QueueSectionComponent.displayName = "QueueSectionComponent";

QueueSectionComponent.propTypes = {
    time: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.number
    ])
};

QueueSectionComponent.defaultProps = {
    time: new Date()
};

export default QueueSectionComponent;
